// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const MaintenancePlanServiceIntervalTypesCriteria = props =>
    <div className='maintenance-plan-service-interval-types-criteria'>
        <OptionsDropDown
            className='service-interval-types-criteria'
            isPlaceholderTranslated={false}
            label='SERVICE_INTERVAL_TYPES'
            onChange={props.onHandleServiceIntervalTypesSelectChange}
            optionDisplayAttributes={['key', 'value']}
            optionKey='key'
            options={props.serviceIntervalTypes}
            placeholder='SELECT_SERVICE_INTERVAL_TYPES'
            selectedValue={props.serviceIntervalType}
        />
    </div>;

MaintenancePlanServiceIntervalTypesCriteria.displayName = 'MaintenancePlanServiceIntervalTypesCriteria';
MaintenancePlanServiceIntervalTypesCriteria.propTypes = {
    onHandleServiceIntervalTypesSelectChange: PropTypes.func.isRequired,
    serviceIntervalType: PropTypes.string.isRequired,
    serviceIntervalTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default MaintenancePlanServiceIntervalTypesCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-service-interval-types-criteria.js